module.exports = __webpack_public_path__ + "static/media/swift.19d95e72.svg";